<template>
    <div class="DashboardView__container">
        <ThePage :class-name="'DashboardView'">
            <template slot="left-action">
                <TheLogo />
            </template>
            <template slot="right-action">

                <!--CONFIGURATION-->
                <BaseNavigationButton :label="'DASHBOARD__CONFIGURATION'"
                                      :icon="'icon-cog'"
                                      @click="openConfiguration" />

            </template>
            <div class="DashboardView__body">

                <!--LIST-->
                <DashboardItem :name="'DASHBOARD__LIST'"
                               :icon="'icon-th-list'"
                               @click="openList" />

                <!--FORM-->
                <DashboardItem :name="'DASHBOARD__FORM'"
                               :icon="'icon-ok-squared'"
                               @click="openForm" />

                <!--TABLE-->
                <DashboardItem :name="'DASHBOARD__TABLE'"
                               :icon="'icon-table'"
                               @click="openTable" />

                <!--CATALOG-->
                <DashboardItem :name="'DASHBOARD__CATALOG'"
                               :icon="'icon-th'"
                               @click="openCatalog" />

            </div>
        </ThePage>

        <!--FORM MODAL-->
        <FormModal v-if="formVisible" />
        <ConfigurationModal v-if="configurationVisible" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ThePage from '../components/common/ThePage.vue';
    import TheLogo from '../components/common/TheLogo.vue';
    import BaseNavigationButton from '../components/common/BaseNavigationButton.vue';
    import DashboardItem from '../components/dashboard/DashboardItem.vue';
    import FormModal from '../components/dashboard/FormModal.vue';
    import ConfigurationModal from '../components/dashboard/ConfigurationModal.vue';

    export default {
        name: 'DashboardView',
        components: {
            ThePage,
            TheLogo,
            BaseNavigationButton,
            DashboardItem,
            FormModal,
            ConfigurationModal
        },
        computed: {
            ...mapState({
                formVisible: s => s.form.visible,
                configurationVisible: s => s.configuration.visible
            })
        },
        methods: {
            ...mapActions({
                openConfiguration: 'configuration/open',
                openList: 'dashboard/openList',
                openForm: 'form/open',
                openTable: 'dashboard/openTable',
                openCatalog: 'dashboard/openCatalog'
            })
        }
    };
</script>

<style>
    .DashboardView__container {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .DashboardView__body {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// DashboardView.vue?f62e1b8a